import React, {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {Box} from '@mui/material';
import {baseUrl, ipAddress, userLocation, userName} from '../../Univ.js'
const IpDrugEntry = (props) => {
    const {pat_id} = useParams();
    const {ip_id} = useParams();
    const [patientData, setPatientData] = useState([]);
    const [items, setItems] = useState([]);
    const [rows, setRows] = useState([{ID: '', Subcat: '', Amount: ''}]);
    const [viewPharmData, setViewPharmData] = useState([]);
    const [drugData, setDrugData] = useState([]);
    const [drugitems, setdrugItems] = useState([]);
    const [drugrows, setdrugrows] = useState([{id: '', product: '', qty: ''}]);
    const nextQtyInputRef = useRef(null);
    const [pharmData, setPharmData] = useState({
        "ip": '',
        "pat": '',
        "drug_id": '',
        "qty": '',
        "drug_status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [patResponse, pharmResponse] = await Promise.all([
                    axios.get(`${baseUrl}pat-id/${pat_id}/`),
                    axios.get(`${baseUrl}indent-pharm-search/?dept=Pharmacy`)
                ]);
                if (patResponse.status === 200 || patResponse.status === 201) {
                    setPatientData(patResponse.data);
                } else {
                    window.location.href = '/pat-search/';
                }
                setdrugItems(pharmResponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        fetchDrugData();
    }, []);
    function fetchDrugData() {
        axios.get(baseUrl + "view-drug-ip/" + ip_id + "/")
            .then(response => {
                setDrugData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        if (Array.isArray(drugData)) {
            const dd = drugData.map(row => row.drug_id);
            if (dd !== null) {
                function fetchPharmData1() {
                    const ipIds = drugData.map(row => row.drug_id?.split(',').map(item => item.trim()));
                    ipIds.forEach(ipId => {
                        try {
                            ipId.forEach(id => {
                                axios.get(baseUrl + 'update-indent-use/' + id + '/')
                                    .then(function (response) {
                                        const data = Object.assign({}, response.data);
                                        setViewPharmData(prevData => [...prevData, data]);
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });
                            });
                        } catch (error) {
                            console.log(error);
                        }
                    });
                }
                fetchPharmData1();
            }
        }
    }, [drugData]);
    const handleKeyDowndrug = (e, index) => {
        const newdrugrows = [...drugrows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === drugrows.length - 1) {
                    newdrugrows.push({id: '', product: '', qty: ''});
                }
                break;
            // Handle arrow up key
            case 18:
                e.preventDefault();
                newdrugrows.splice(index, 1);
                break;
            case 38:
                e.preventDefault();
                if (newdrugrows[index].selectedItemdrug === 0) {
                    newdrugrows[index].selectedItemdrug = drugitems.length - 1;
                } else {
                    newdrugrows[index].selectedItemdrug--;
                }
                setdrugrows(newdrugrows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (newdrugrows[index].selectedItemdrug === drugitems.length - 1) {
                    newdrugrows[index].selectedItemdrug = 0;
                } else {
                    newdrugrows[index].selectedItemdrug++;
                }
                setdrugrows(newdrugrows);
                break;
            default:
                break;
        }
        setdrugrows(newdrugrows);
    };
    const handleSelectdrug = (val, index, id) => {
        const selectedItemdrug = val;
        const newdrugrows = [...drugrows];
        newdrugrows[index] = {
            id: selectedItemdrug.id,
            product: selectedItemdrug.product.product,
            qty: '',
        };
        setdrugrows(newdrugrows);
        if (nextQtyInputRef.current) {
            nextQtyInputRef.current.focus();
        }
    };
    const handleAddRowdrug = () => {
        const newdrugrows = [...drugrows];
        newdrugrows.push({id: '', product: '', qty: ''});
        setdrugrows(newdrugrows);
    };
    const inputdrugRefs = useRef([]);
    useEffect(() => {
        inputdrugRefs.current[inputdrugRefs.current.length - 1]?.focus();
    }, [drugrows.length]);
    const handleDeleteRowdrug = (index) => {
        const newdrugrows = [...drugrows];
        newdrugrows.splice(index, 1);
        setdrugrows(newdrugrows);
    };
    const handledrugChange = (event, index) => {
        const {name, value} = event.target;
        const newdrugrows = [...drugrows];
        newdrugrows[index][name] = value;
        setdrugrows(newdrugrows);
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('ip', ip_id);
        formData.append('pat', patientData[0].id);
        formData.append('drug_id', drugrows.map(row => row.id).join(','));
        formData.append('qty', drugrows.map(row => row.qty).join(','));
        formData.append('drug_status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(`${baseUrl}ip-drug-create/`, formData)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    setPharmData({
                        ip: '',
                        pat: '',
                        drug_id: '',
                        drug_status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/nurse-pat-view/' + ip_id + '/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed. Please try again later.',
                    'error'
                );
            });
    };
    const customFilterOptions = (options, state) => {
        const inputValue = state.inputValue.toLowerCase();
        if (inputValue.length < 3) {
            return [];
        }
        const filteredOptions = options.filter(option => {
            const label = (option.label || option.product?.product || '').toLowerCase();
            return label.startsWith(inputValue);
        });
        return filteredOptions;
    };
    return (
        <section className="container mt-4">
            <form>
                <div className="row table-responsive">
                    <div className='col-md-12 col-12 mb-2'>
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Patient ID</th>
                                <th>Patient Name</th>
                                <th>Gender</th>
                                <th>D.O.B/Age</th>
                                <th>Marital Status</th>
                                <th>Regd. On</th>
                                <th>Occupation</th>
                            </tr>
                            </thead>

                            <tbody>
                            {patientData.map((patientData, index) => (
                                <tr key={index}>
                                    <td>{patientData.pat_id}</td>
                                    <td>{patientData.patient}</td>
                                    <td>{patientData.gender}</td>
                                    <td>{patientData.age}</td>
                                    <td>{patientData.marital_status}</td>
                                    <td>{patientData.add_date}</td>
                                    <td>{patientData.occupation}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th style={{width: 50}}>ID</th>
                            <th style={{width: 300}}>Drug name</th>
                            <th style={{width: 70}}>QTY</th>
                            <th style={{width: 70}}>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {drugrows.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="text"
                                        name="drug_id"
                                        tabIndex={-1}
                                        value={row.id}
                                        onChange={handledrugChange}
                                        readOnly
                                        style={{width: 90}}
                                    />
                                </td>
                                <td>
                                    <AutoComplete
                                        items={drugitems}
                                        options={drugitems}
                                        sx={{width: 200}}
                                        componentsProps={{
                                            paper: {
                                                sx: {
                                                    width: 800
                                                }
                                            }
                                        }}
                                        fullWidth
                                        onKeyDown={e => handleKeyDowndrug(e, index)}
                                        onChange={(event, val, id) => handleSelectdrug(val, index, id)}
                                        getOptionLabel={(option) => option.product ? option.product.product : ''}

                                        renderOption={(props, option) => (
                                            <Box component="li" {...props}
                                                 fullWidth
                                                 sx={{
                                                     width: 750,
                                                     height: 50,
                                                     borderRadius: 1,
                                                 }}
                                            >
                                                {option.product ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch}
                TQty: ${option.qty} ` : ''}
                                            </Box>
                                        )}
                                        renderInput={(params) => (
                                            <div ref={params.InputProps.ref}>
                                                <input className="form-control" type="text" {...params.inputProps}
                                                       fullWidth focused autoFocus
                                                       style={{
                                                           background: "#F7EEFF",
                                                           width: 250,
                                                       }}
                                                />
                                            </div>
                                        )}
                                        ref={(el) => inputdrugRefs.current[index] = el}
                                        filterOptions={customFilterOptions}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="ms-4 me-5"
                                        min={0}
                                        tabIndex={0}
                                        value={row.qty}
                                        name="qty"
                                        onKeyDown={e => handleKeyDowndrug(e, index)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                handledrugChange(e, index)
                                            }
                                        }}
                                        required
                                        ref={nextQtyInputRef}
                                        style={{width: 130}}
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-danger" type="button"
                                            onClick={() => handleDeleteRowdrug(index)}>Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRowdrug}>Add More
                </button>
                <div className="row">
                    <div className="col-md-12 text-center mb-5">
                        <button type="button" onClick={formSubmit}
                                className="btn btn-success">Submit
                        </button>
                    </div>
                </div>
            </form>
            <div className="row mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    Medicine Request View</h3>
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Date</th>
                        <th>Drug ID</th>
                        <th>Drug Name</th>
                        <th>Dose</th>
                        <th>Addedby</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Array.isArray(drugData) && drugData.map((row) => (
                        <tr key={row.id}>
                            <td>{row.add_date}</td>
                            <td>{row.drug_id?.split(',').map((value, index) => <span
                                key={index}>{value}<br/></span>)}</td>
                            <td>
                                {row.drug_id?.split(',').map((drugId, index) => {
                                    const id = drugId.trim();
                                    const pharmData = viewPharmData?.find(
                                        (data) => String(data.id) === id
                                    );
                                    return (
                                        <span key={index}>
                {pharmData ? pharmData.product_name : 'Drug not found'}
                                            <br/>
            </span>
                                    );
                                })}
                            </td>
                            <td>{row.qty?.split(',').map((value, index) => <span key={index}>{value}<br/></span>)}</td>
                            <td>{row.addedby}</td>
                            <td>
                                {row.drug_status == '1' ? (
                                    <span className="badge bg-warning">Sent To Pharmacy</span>
                                ) : (
                                    <span>unknown status</span>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>


        </section>
    );
};
export default IpDrugEntry;
